export default {
  header: "404 error, invoked the wrath of the pharaoh (bad harvest this year, sorry)",
  view: "viewNotFound"
};
